<template>
  <div class="w-100">
    <b-row v-if="isRmaAsTab">
      <b-col>
        <div class="d-flex justify-content-end mb-2">
          <add-rma-component
            :invoiceId="invoiceId"
            :salesOrderId="salesOrderId"
            :companyName="companyName"
          />
        </div>
      </b-col>
    </b-row>
    <grid-component
      isResizable
      isReorderable
      :canEdit="checkClaim(CAN_EDIT_RMAS)"
      :canDelete="checkClaim(CAN_DELETE_RMAS)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="fields"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :handleRowClick="onRowClick"
      :navigationField="navField"
    />
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import AddRmaComponent from '../add/index';
  import { GRID_ID } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from './fields';
  import tabFields from './tabFields';

  export default {
    components: {
      GridSettings,
      GridComponent,
      AddRmaComponent,
    },
    props: {
      customerRMAId: {
        type: [Number, String],
        default: 0,
      },
      showAllGridRows: {
        type: [Boolean],
        default: false,
      },
      isRmaAsTab: {
        type: Boolean,
        default: false,
      },
      invoiceLineId: {
        type: [Number, String],
        default: 0,
      },
      invoiceId: {
        type: [Number, String],
        default: 0,
      },
      salesOrderLineId: {
        type: [Number, String],
        default: 0,
      },
      salesOrderId: {
        type: [Number, String],
        default: 0,
      },
      companyId: {
        type: [Number, String],
        default: 0,
      },
      companyName: {
        type: String,
        default: null,
      },
      partId: {
        type: [Number, String],
        default: 0,
      },
      id: {
        type: [Number, String],
        default: 0,
      },
      inventoryId: {
        type: [Number, String],
        default: 0
      }
    },
    data: () => ({
      selectedRowItemId: 0,
      lineGridId: GRID_ID.CUSTOMER_RMA_LINES,
      tabGridId: GRID_ID.CUSTOMER_RMA_LINES_TAB,
      gridFields,
      tabFields,
      checkedRowItemIds: [],
      unHideRMAActions: [
        'rtnCheckbox', 'rplCheckbox', 'crLabel',
      ],
    }),
    computed: {
      ...mapGetters('account', ['gridSettingsById']),
      ...mapGetters('customerRmasLines', ['customerRMALines', 'rmaLinesByFilter']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        const rmaLine = this.isRmaAsTab ? this.rmaLinesByFilter : this.customerRMALines;
        if (rmaLine == undefined || !rmaLine.length) return [];
        return rmaLine.map((customerRMALine) => ({
          ...customerRMALine,
          selected: customerRMALine.id === this.selectedRowItemId,
        }));
      },
      fields() {
        return this.isRmaAsTab ? this.tabFields : this.gridFields;
      },
      gridId() {
        return this.isRmaAsTab ? this.tabGridId : this.lineGridId;
      },
      navField() {
        return this.isRmaAsTab ? 'rmaId' : 'partNumber';
      },
    },
    methods: {
      ...mapActions('customerRmasLines', ['getCustomerRMALines', 'getLinesByFilter']),
      ...mapMutations('customerRmasLines',['setItem']),
      onRowClick(row) {
        this.selectedRowItemId = row.dataItem.id;
      },
      onEdit(data) {
        console.log(data, 'RMA Check');
        if (this.isRmaAsTab) {
          this.$router.push({
            name: 'customerrmas.edit',
            params: { id: data.rmaId },
          });
        } else {
          this.$emit('showEdit', data);
        }
      },
      onDelete(data) {
        this.$emit('showDelete', data);
      },
      async generateFilter() {
        let filters = `{`;
        let flagForCall = false;

        if (this.invoiceLineId > 0) {
          flagForCall = true;
          filters += `invoiceLineId: ${this.invoiceLineId},`;
        }
        if (this.salesOrderLineId > 0) {
          flagForCall = true;
          filters += `SOLineId: ${this.salesOrderLineId},`;
        }
        if (this.companyId > 0) {
          flagForCall = true;
          filters += `CompanyId: ${this.companyId},`;
        }
        if (this.partId > 0) {
          flagForCall = true;
          filters += `PartId: ${this.partId}`;
        }
        if (this.id > 0) {
          flagForCall = true;
          filters += `Id: ${this.id}`;
        }
        if (this.inventoryId > 0) {
          flagForCall = true;
          filters += `InventoryId: ${this.inventoryId}`;
        }

        filters += `}`;

        // If there's a filter, then call the API, else, make it empty
        if (flagForCall) {
          await this.getLinesByFilter(filters);
        } else {
          this.setItem({ resource: 'rmaLinesByFilter', payload: [] });
        }
      },
    },
    watch: {
      customerRMAId() {
        this.setItem({ resource: 'customerRMALines', payload: [] });
        if (this.customerRMAId) {
          this.getCustomerRMALines(this.customerRMAId);
        }
      },
      async customerRMALines() {
        //This function sets the first row as the selected row
        this.selectedRowItemId = await this.setSelectedRowId(this.customerRMALines,this.selectedRowItemId);
      },
      selectedRowItemId(newVal) {
        const selectedRow = this.customerRMALines.find(customerRMALines => customerRMALines.id === newVal);
        this.$emit('selectedCustomerRMALine', selectedRow);
      },
      invoiceLineId() {
        this.generateFilter();
      },
      salesOrderLineId() {
        this.generateFilter();
      },
      companyId() {
        this.generateFilter();
      },
      partId() {
        this.generateFilter();
      },
      inventoryId() {
        this.generateFilter();
      },
      id() {
        this.generateFilter();
      }
    },
    mounted() {

      if (this.companyId || this.id) {
        this.generateFilter();
      }
      if (this.customerRMAId) {
        this.getCustomerRMALines(this.customerRMAId);
      }
    },
  };
</script>

<style scoped>
  .sales-order-lines-grid {
    height: 185px !important;
  }
</style>
